<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Vue from "vue";
import { Icons } from "vue-ydui/dist/lib.rem/icons";
Vue.component(Icons.name, Icons);
import initSignalr from "@/utils/signalr"

export default {
  name: "App",
  data(){
    return{
      cardInfo:{}
    }
  },
  created() {
    this.$store.dispatch("loginInfo").then((cardInfo)=>{
        this.cardInfo = Object.assign({}, cardInfo);
        this.$connection.on("getAllDoctors", (data) => {});
       initSignalr(this.$connection,this.cardInfo)
      });

  },
  mounted() {
    window.addEventListener("popstate", e => {
      if (e.target.location.hash == "#/App/Home") {
        history.pushState(null, null, e.target.location.href);
      }
    });
  },
  data() {
    return {
      routeNme: "",
    };
  },
  watch: {
    $route: function(route) {
      this.routeNme = route.name;
    }
  },
  methods: {
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  overflow-y: scroll;
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue